import { IMytaverseFile } from './file';
import { IAvatarSkin } from './avatarSkin';
import { AvaturnStatuses } from '@features/avaturn/interfaces';

export enum AvatarGender {
  Female = 'female',
  Male = 'male',
}

export enum AvatarTypes {
  AVATURN = 'AVATURN',
  READY_PLAYER_ME = 'READY_PLAYER_ME',
  MYTAVERSE = 'MYTAVERSE',
}

export interface IAvatar {
  name: string;
  avatarId: string;
  rootAvatarId: string;
  gender: AvatarGender;
  isDefault: boolean;
  image: string;
  status: string;
  avatarImage: IMytaverseFile;
  type: string;

  skins: IAvatarSkin[];
}

export interface IAvatarMessage {
  avatarId: string;
  type: string | undefined;
  skinId: string;
  downloadAvatarUrl: string;
}

export interface IAvatarAssets {
  assetId: string;
  uniforms?: string[];
  glasses?: string[];
  shoes?: string[];
  hair?: string[];
  default?: string[];
  assetsBodyType0?: string[];
}
export interface IUserAvatar {
  avatarId: string;
  avatarUrl: string;
  avatarPic?: string;
  avatarType: AvatarTypes;
  tags: string[];
  assetId?: string;
}

export enum AvaturnCreationType {
  NEW_AVATAR = 'NEW_AVATAR',
  CHANGE_AVATAR = 'CHANGE_AVATAR',
}

export interface AvaturnChangeAsset {
  brand: string;
  gender?: string;
  ixrCredentialStatus?: string;
  persona?: string;
  finalState?: AvaturnStatuses;
  baseAvatarId?: string;
  type?: AvaturnCreationType;
  childAvaturnId?: string;
}

export interface IAvatarLimited {
  avatarId: string;
  avaturnId: string;
  tags: string[];
  status: AvaturnStatuses;
  changeAssets?: AvaturnChangeAsset | null;
  hasPhotoUrls: boolean;
  hasAvatarUrl: boolean;
}
